import request from '@/utils/httpRequest'

//   场馆预览列表页
export function getdigitlist (query) {
  return request({
    url: 'api/onlinevenues/web/page',
    method: 'get',
    params: query
  })
}

//  场馆预览详情页
export function getdigitdetail (id) {
  return request({
    url: 'api/onlinevenues/web/preview/' + id,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/digitalpavilion/index.js